import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "@/api/constant";
// import type { departmentResponse } from "@/interface/department.interface";
import type {
  IshiftAndTimeIdResponse,
  IshiftAndTimeResponse,
  shiftAndTime,
} from "@/interface/shiftAndTime.interface";

const ShiftAndTimeService = {
  createShiftAndTime: async (
    payload: shiftAndTime,
  ): Promise<IshiftAndTimeResponse> => {
    const API = `${API_ENDPOINT.shift}`;
    return callApi<IshiftAndTimeResponse>(API, {
      method: "POST",
      data: payload,
    });
  },

  getShiftAndTime: async (params?: string): Promise<IshiftAndTimeResponse> => {
    const API = `${API_ENDPOINT?.shift}${params ? `?${params}` : ""}`;
    return callApi<IshiftAndTimeResponse>(API, { method: "GET" });
  },

  updateShiftAndTime: async (
    payload: shiftAndTime,
    id: string,
  ): Promise<IshiftAndTimeResponse> => {
    const API = `${API_ENDPOINT?.shift}/${id}`;
    return callApi<IshiftAndTimeResponse>(API, {
      method: "PUT",
      data: payload,
    });
  },

  deleteShiftAndTime: async (id: string): Promise<IshiftAndTimeResponse> => {
    const API = `${API_ENDPOINT?.shift}/${id}`;
    return callApi<IshiftAndTimeResponse>(API, { method: "DELETE" });
  },

  getShiftAndTimeById: async (id: string): Promise<IshiftAndTimeIdResponse> => {
    const API = `${API_ENDPOINT?.shift}/${id}`;
    return callApi<IshiftAndTimeIdResponse>(API, { method: "GET" });
  },
};

export default ShiftAndTimeService;
